export default __webpack_public_path__ + "images/03751f5d45b0c9f26f8a3f80e49514f4.png";